import { useContext } from 'react';
import { AlertDialogContext } from './AlertDialogContext';

export default function useAlertDialog() {
  const alertDialog = useContext(AlertDialogContext);

  if (!alertDialog) {
    throw new Error("useAlertDialog: no AlertDialogProvider mounted. Mount <SharedProviders> (from 'shared').");
  }

  return alertDialog;
}
